import { fileService } from "@services";
import { Directory } from "@interfaces/Directory";

/** Кэш уровня модуля: общие предки (корень, категория, бренд) повторяются
 * на каждом переходе между соседними папками в дереве файлового хранилища —
 * без кэша это лишний сетевой round-trip на каждый клик, даже когда предок
 * уже был загружен минуту назад. Директории в рамках одной сессии меняются
 * редко, инвалидация не нужна. */
const directoryCache = new Map<number, Directory>();

export const getCachedDirectory = async (id: number): Promise<Directory | undefined> => {
    let directory = directoryCache.get(id);

    if (!directory) {
        const { result } = await fileService.getDirectories({ ids_list: id });
        directory = result.items[0];
        if (directory) directoryCache.set(id, directory);
    }

    return directory;
};

/** Цепочка от настоящего корня хранилища до directoryId, включительно. */
export const resolveDirectoryChain = async (directoryId: number): Promise<Directory[]> => {
    const chain: Directory[] = [];
    let currentId: number | null = directoryId;

    while (currentId) {
        const directory = await getCachedDirectory(currentId);
        if (!directory) break;

        chain.unshift(directory);
        currentId = directory.parent_dir_id ?? null;
    }

    return chain;
};
